import { Modal, Button, Form, Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

const MAX_CHARS = 1000;

const ApplyToModerateModal = ({
    show,
    onHide,
    onSubmit,
    submitting = false,
    error = null,
}) => {
    const [text, setText] = useState('');
    const [validationError, setValidationError] = useState(null);

    // Reset the field each time the modal is (re)opened.
    useEffect(() => {
        if (show) {
            setText('');
            setValidationError(null);
        }
    }, [show]);

    const handleChange = (e) => {
        setText(e.target.value);
        if (validationError) setValidationError(null);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Client-side validation BEFORE hitting the API.
        if (!text.trim()) {
            setValidationError(
                'Please explain why you would like to moderate.'
            );
            return;
        }
        onSubmit(text.trim());
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            aria-labelledby="apply-moderate-title"
        >
            <Modal.Header closeButton>
                <Modal.Title as="h2" id="apply-moderate-title" className="fs-4">
                    Apply to Moderate
                </Modal.Title>
            </Modal.Header>

            {/* noValidate: we render our own messages instead of the browser's */}
            <Form noValidate onSubmit={handleSubmit}>
                <Modal.Body>
                    <p className="text-muted">
                        Tell us why you&apos;d like to moderate this community.
                    </p>

                    {error && <Alert variant="danger">{error}</Alert>}

                    <Form.Group controlId="moderatorApplicationText">
                        <Form.Control
                            as="textarea"
                            rows={4}
                            maxLength={MAX_CHARS}
                            value={text}
                            onChange={handleChange}
                            isInvalid={!!validationError}
                            placeholder="Share a bit about why you would be a good moderator..."
                        />
                        <Form.Control.Feedback type="invalid">
                            {validationError}
                        </Form.Control.Feedback>
                        <Form.Text
                            className="d-block text-end"
                            aria-live="polite"
                        >
                            {text.length} / {MAX_CHARS}
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} type="button">
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={submitting}
                    >
                        {submitting ? 'Submitting…' : 'Submit'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

ApplyToModerateModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.string,
};

export default ApplyToModerateModal;
